import type { PublicTransfer } from '../types'
import { FileIcon } from './FileIcon'

interface DecryptingStateProps {
  transfer: PublicTransfer
}

export function DecryptingState({ transfer }: DecryptingStateProps) {
  const file = transfer.files[0]

  return (
    <div>
      {/* File info */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 'var(--space-md)',
        marginBottom: 'var(--space-xl)',
      }}>
        <FileIcon filename={file?.name || ''} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ 
            fontWeight: 500,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>
            {file?.name || 'Encrypted file'}
          </div>
        </div>
      </div>

      {/* Decrypting animation */}
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '80px',
          height: '80px',
          margin: '0 auto var(--space-lg)',
          position: 'relative',
        }}>
          {/* Outer ring */}
          <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            style={{ position: 'absolute', top: 0, left: 0 }}
          >
            <circle
              cx="40"
              cy="40"
              r="36"
              stroke="var(--border)"
              strokeWidth="3"
              fill="none"
            />
            <circle
              cx="40"
              cy="40"
              r="36"
              stroke="var(--accent)"
              strokeWidth="3"
              fill="none"
              strokeDasharray="226"
              strokeDashoffset="56"
              strokeLinecap="round"
              className="animate-spin"
              style={{ transformOrigin: 'center' }}
            />
          </svg>
          
          {/* Lock/unlock icon */}
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="11" width="18" height="11" rx="2" stroke="var(--accent)" strokeWidth="2" />
              <path d="M7 11V7C7 4.23858 9.23858 2 12 2V2C14.7614 2 17 4.23858 17 7" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </div>
        </div>

        <h3 style={{ 
          fontSize: '18px', 
          fontWeight: 600,
          marginBottom: 'var(--space-sm)',
        }}>
          Decrypting...
        </h3>
        
        <p style={{ 
          color: 'var(--text-muted)', 
          fontSize: '14px',
          maxWidth: '280px',
          margin: '0 auto',
        }}>
          Your file is being decrypted locally in your browser. This may take a moment.
        </p>
      </div>
    </div>
  )
}
